import React, { FC, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { PageRoutes, axios, useViewModel } from '../../../utils';
import '../../../styles/views/emailConfirmationPage/emailConfirmationPage.scss';
import { PageWrapper } from '../../../components';
import { LoginViewModel } from '../../loginPage';
import { EmailConfirmationContent } from './components';

export const EmailConfirmationPage: FC = () => {
  const auth = useViewModel(LoginViewModel);
  const location = useLocation();
  const [hashId, setHashId] = useState('');
  const [data, setData] = useState('');
  const navigate = useNavigate();

  const verifyEmail = () => {
    if (hashId) {
      axios
        .get(`/user/email/verify?id=${hashId}`)
        .then((resp) => setData(resp.data));
    }
  }

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search);
    const userHash = searchParams.get('id');
    
    userHash 
      ? setHashId(userHash) 
      : navigate(PageRoutes.CALENDAR_PAGE);
  }, [location]);

  useEffect(() => {
    verifyEmail();
  }, [hashId]);

  const redirectToCalendar = () => {
    navigate(PageRoutes.CALENDAR_PAGE);
  }

  const content = <EmailConfirmationContent data={data} redirectToCalendar={redirectToCalendar} />

  return (
    auth.authorized 
    ? (
      <PageWrapper>
        {content}
      </PageWrapper>
    )
    : content
  )
} 
